import React, { useEffect, useState } from "react";
import MangeDashboard from "./ManageDashboard";
import StepRequest from "./StepRequest";
import { useNavigate, useSearchParams } from "react-router-dom";
import AfterLoginNav from "../AfterLoginNav";
import { getTransactionsHistory } from "../../services/bank";
import { getUserValidationResult } from "../../services/auth";
import { getCommoditiesList } from "../../services/commodities";
export default function Requests() {
  const [dataType, setDataType] = useState(-1);
  const [page, setPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeParams = searchParams.get("active");
  const [active, setActive] = useState(activeParams ? activeParams : "auth");
  const [BuyReq, setBuyReq] = useState([]);
  const [SellReq, setSellReq] = useState([]);
  const [WidReq, setWidReq] = useState([]);
  const [PgodldReq, setPgoldReq] = useState([]);
  const navigate = useNavigate();
  const [validationResult, setValidationResult] = useState({});
  const [hasNext, setHasNext] = useState(false);

  useEffect(() => {
    if (!isNaN(dataType) && dataType > 0) {
      getCommoditiesList().then((result) => {
        if (result.status === 200) {
          const comms = result.data.results;
          getTransactionsHistory(page, dataType).then((res) => {
            if (res.status == 200) {
              let data = res?.data?.results;
              for (let d of data) {
                const selected = comms.find((el) => el.id == d?.commodity?.id);
                if (selected) {
                  d.commodity.color = selected.ui_data.colors.primary;
                }
              }
              if (dataType === 3) {
                setWidReq([...WidReq, ...data]);
              }
              if (dataType === 1) {
                for (let d of data) {
                  const selected = comms.find((el) => el.id == d.commodity.id);
                  d.commodity.color = selected.ui_data.colors.primary;
                }

                setBuyReq([...BuyReq, ...data]);
              }
              if (dataType === 2) {
                setSellReq([...SellReq, ...data]);
              }
              if (dataType === 4) {
                setPgoldReq([...PgodldReq, ...data]);
              }
              setHasNext(res?.data?.next);
            }
          });
        }
      });
    } else if (dataType === -1) {
      getUserValidationResult().then(({ data }) => {
        if (data?.data) {
          setValidationResult(data.data);
        }
      });
    }
  }, [page, dataType]);

  useEffect(() => {
    setPage(1);
  }, [active]);

  return (
    <MangeDashboard>
      <AfterLoginNav title={"پیگیری درخواست"} hasBack={() => navigate(-1)} />
      <div className="container wrapper-for-requests-container">
        <div className="row justify-content-center align-items-center">
          <div className="col-xl-8 col-md-8">
            <div>
              <div className="wrapper-for-requests">
                <div
                  className={
                    active == "auth"
                      ? "form-input-button-custom"
                      : "form-input-button-custom not-active-login"
                  }
                  onClick={() => {
                    setDataType(-1);
                    setActive("auth");
                  }}
                >
                  احراز
                </div>
                <div
                  className={
                    active == "buy"
                      ? "form-input-button-custom"
                      : "form-input-button-custom not-active-login"
                  }
                  onClick={() => {
                    setActive("buy");
                    setDataType(1);
                    setBuyReq([]);
                  }}
                >
                  خرید
                </div>
                <div
                  className={
                    active == "sell"
                      ? "form-input-button-custom"
                      : "form-input-button-custom not-active-login"
                  }
                  onClick={() => {
                    setActive("sell");
                    setDataType(2);
                    setSellReq([]);
                  }}
                >
                  فروش
                </div>
                <div
                  className={
                    active == "wid"
                      ? "form-input-button-custom"
                      : "form-input-button-custom not-active-login"
                  }
                  onClick={() => {
                    setActive("wid");
                    setDataType(3);
                    setWidReq([]);
                  }}
                >
                  برداشت
                </div>
                <div
                  className={
                    active == "pgold"
                      ? "form-input-button-custom"
                      : "form-input-button-custom not-active-login"
                  }
                  onClick={() => {
                    setActive("pgold");
                    setDataType(4);
                    setPgoldReq([]);
                  }}
                >
                  تحویل
                </div>
              </div>
            </div>

            {active == "auth" && (
              <div className="pr-16">
                <div className="d-flex pb-2">
                  <div>
                    {validationResult.first_name &&
                    validationResult.last_name ? (
                      <img src="./images/svg/accept.svg" alt="" />
                    ) : (
                      <img src="./images/svg/reject.svg" alt="" />
                    )}
                  </div>
                  <div className="pe-3">نام و نام خانوادگی</div>
                </div>

                <div className="d-flex pb-2">
                  {validationResult.national_code ? (
                    <img src="./images/svg/accept.svg" alt="" />
                  ) : (
                    <img src="./images/svg/reject.svg" alt="" />
                  )}
                  <div className="pe-3">کد ملی</div>
                </div>

                <div className="d-flex">
                  {validationResult.mobile_number ? (
                    <img src="./images/svg/accept.svg" alt="" />
                  ) : (
                    <img src="./images/svg/reject.svg" alt="" />
                  )}
                  <div className="pe-3">شماره همراه</div>
                </div>

                <div className="d-flex pt-2 pb-2">
                  {validationResult.birth_date ? (
                    <img src="./images/svg/accept.svg" alt="" />
                  ) : (
                    <img src="./images/svg/reject.svg" alt="" />
                  )}
                  <div className="pe-3">تاریخ تولد</div>
                </div>
                <div className="d-flex pb-2">
                  {validationResult.bank_account ? (
                    <img src="./images/svg/accept.svg" alt="" />
                  ) : (
                    <img src="./images/svg/reject.svg" alt="" />
                  )}
                  <div className="pe-3">شماره کارت</div>
                </div>

                <div className="d-flex">
                  {validationResult.sheba_number ? (
                    <img src="./images/svg/accept.svg" alt="" />
                  ) : (
                    <img src="./images/svg/reject.svg" alt="" />
                  )}
                  <div className="pe-3">شماره شبا</div>
                </div>
              </div>
            )}

            {active == "buy" && (
              <>
                <StepRequest reqs={BuyReq} typeList={active} />
                {hasNext && (
                  <button
                    className="btn-submit"
                    onClick={() => setPage(page + 1)}
                  >
                    صفحه بعد
                  </button>
                )}
              </>
            )}

            {active == "sell" && (
              <>
                <StepRequest reqs={SellReq} typeList={active} />
                {hasNext && (
                  <button
                    className="btn-submit"
                    onClick={() => setPage(page + 1)}
                  >
                    صفحه بعد
                  </button>
                )}
              </>
            )}

            {active == "wid" && (
              <>
                <StepRequest reqs={WidReq} typeList={active} />
                {hasNext && (
                  <button
                    className="btn-submit"
                    onClick={() => setPage(page + 1)}
                  >
                    صفحه بعد
                  </button>
                )}
              </>
            )}

            {active == "pgold" && (
              <>
                <StepRequest reqs={PgodldReq} typeList={active} />
                {hasNext && (
                  <button
                    className="btn-submit"
                    onClick={() => setPage(page + 1)}
                  >
                    صفحه بعد
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </MangeDashboard>
  );
}
